// extracted by mini-css-extract-plugin
export default {"selector":"page-selector_selector__Ovn96","item":"page-selector_item__+oYsh"};